<div
  *ngIf="maintenanceModeService.maintenanceMode.active"
  class="maintenance-mode-header"
>
  <maintenance-mode-banner></maintenance-mode-banner>
</div>